import React, { useEffect, useState, useMemo } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";
import ScheduleIcon from "@mui/icons-material/Schedule";
import TuneIcon from "@mui/icons-material/Tune";
import CategoryIcon from "@mui/icons-material/Category";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import StudentResult from "./StudentResult";
import StudentBacklogsReport from "./StudentBacklogsReport";
import StudentResultHistory from "./StudentResultHistory";
import EnrollRevaluation from "./EnrollRevaluation";
import EnrollSupply from "./EnrollSupply";
import ServiceTypes from "./ServiceTypes";
import ServiceRequest from "./ServiceRequest";
import HostelEnrollement from "./HostelEnrollement";
import TransportEnrollment from "./TransportEnrollment";
import Routes from "../Office/Routes";
import Overview from "./StudentProfile";
import ActivityCategories from "./ActivityCategories";
import StudentActivityDetailsUpload from "./StudentActivityDetailsUpload";
import StudentServiceRequest from "./StudentServiceRequest";
import StudentFeeHistory from "../Fee/StudentFeeHistory";
function Student() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState("home");
  const navigate = useNavigate();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const user = useMemo(() => {
    try {
      const userStr = sessionStorage.getItem("user");
      return userStr ? JSON.parse(userStr) : null;
    } catch (err) {
      return null;
    }
  }, []);
  const [studentDetails, setStudentDetails] = useState({
    student_id: null,
    student_rollno: "",
    student_name: "",
  });
  const params = new URLSearchParams(user.client_id ? { client_id: user.client_id } : {});
  let addedAny = false;
  const emailFromUser = user.email || user.user_email;
  if (emailFromUser) {
    params.append("email", emailFromUser);
    addedAny = true;
  }

  if (user.student_id) {
    params.append("student_id", user.student_id);
    addedAny = true;
  }
  if (user.user_id) {
    params.append("user_id", user.user_id);
    addedAny = true;
  }
  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };

  useEffect(() => {
    const fetchStudentDetails = async () => {
      try {
        const token = sessionStorage.getItem("token");

        if (!token) {
          navigate("/authentication/sign-in");
          return;
        }

        const response = await axios.get(`${apiBaseUrl}/api/profile?${params.toString()}`, {
          headers: getAuthHeaders(),
        });

        if (response.data.success) {
          const profileData = response.data.data;

          setStudentDetails({
            student_id: profileData.student.student_id ?? null,
            student_rollno: profileData.student.student_rollno ?? "",
            student_name: profileData.student.student_name ?? "",
          });
        }
      } catch (error) {
        console.error("Failed to fetch student details:", error);
      }
    };

    fetchStudentDetails();
  }, [apiBaseUrl, navigate]);

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleNavigate = (path) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/authentication/sign-in");
    } else {
      setActiveView(path);
    }
  };

  const handleBack = () => {
    setActiveView("home");
  };

  const renderContent = () => {
    switch (activeView) {
      case "studentservicerequest":
        return <StudentServiceRequest />;
      case "servicetypes":
        return (
          <>
            <ServiceTypes />
          </>
        );
      case "servicerequest":
        return (
          <>
            <ServiceRequest />
          </>
        );
      case "hostelenrollement":
        return (
          <>
            <HostelEnrollement />
          </>
        );
      case "transportenrollment":
        return (
          <>
            <TransportEnrollment />
          </>
        );
      case "routes":
        return (
          <>
            <Routes />
          </>
        );
      case "studentresult":
        return (
          <>
            <StudentResult />
          </>
        );
      case "backlogsreport":
        return (
          <>
            <StudentBacklogsReport />
          </>
        );
      case "studentresulthistory":
        return (
          <>
            <StudentResultHistory />
          </>
        );
      case "profile":
        return (
          <>
            <Overview />
          </>
        );
      case "activitycategories":
        return (
          <>
            <ActivityCategories />
          </>
        );
      case "studentactivitydetailsupload":
        return (
          <>
            <StudentActivityDetailsUpload />
          </>
        );
      case "enrollrevaluation":
        return (
          <>
            <EnrollRevaluation />
          </>
        );
      case "enrollsupply":
        return (
          <>
            <EnrollSupply />
          </>
        );

      case "studentfeehistory":
        return (
          <StudentFeeHistory
            initialStudent={
              studentDetails.student_id && studentDetails.student_rollno ? studentDetails : null
            }
          />
        );
      default:
        return (
          <Grid container spacing={2.5} sx={{ p: { xs: 1, sm: 2 } }}>
            {[
              {
                label: "STUDENT PROFILE",
                description: "View your personal and academic details",
                icon: "person",
                view: "profile",
                colors: ["#1565C0", "#42A5F5"],
              },
              {
                label: "FEE HISTORY",
                description: "Review fee payments and transaction history",
                icon: "account_balance_wallet",
                view: "studentfeehistory",
                colors: ["#00897B", "#4DB6AC"],
              },
              {
                label: "STUDENT RESULT",
                description: "View examination results and marks",
                icon: "emoji_events",
                view: "studentresult",
                colors: ["#6A1B9A", "#AB47BC"],
              },
              {
                label: "SERVICE REQUEST",
                description: "Submit and track your service requests",
                icon: "support_agent",
                view: "studentservicerequest",
                colors: ["#EF6C00", "#FFA726"],
              },
              {
                label: "ENROLL REVALUATION",
                description: "Apply for revaluation of examination results",
                icon: "fact_check",
                view: "enrollrevaluation",
                colors: ["#C62828", "#EF5350"],
              },
              {
                label: "ENROLL SUPPLY COURSES",
                description: "Register for supplementary examinations",
                icon: "menu_book",
                view: "enrollsupply",
                colors: ["#2E7D32", "#66BB6A"],
              },
            ].map((item) => (
              <Grid item xs={12} sm={6} md={3} lg={3} key={item.view}>
                <MDButton
                  fullWidth
                  variant="gradient"
                  onClick={() => handleNavigate(item.view)}
                  sx={{
                    minHeight: 125,
                    height: "100%",
                    p: 0,
                    borderRadius: "18px",
                    overflow: "hidden",
                    textTransform: "none",
                    whiteSpace: "normal",
                    background: `linear-gradient(135deg, ${item.colors[0]} 0%, ${item.colors[1]} 100%)`,
                    boxShadow: `0 6px 18px ${alpha(item.colors[0], 0.25)}`,
                    transition: "all 0.25s ease",
                    "&:hover": {
                      background: `linear-gradient(135deg, ${item.colors[0]} 0%, ${item.colors[1]} 100%)`,
                      transform: "translateY(-5px)",
                      boxShadow: `0 12px 26px ${alpha(item.colors[0], 0.35)}`,
                    },
                    "&:active": {
                      transform: "translateY(-1px)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      minHeight: 125,
                      gap: 2,
                      px: { xs: 2, sm: 2.5 },
                      py: 2,
                      textAlign: "left",
                    }}
                  >
                    <Box
                      sx={{
                        width: 58,
                        height: 58,
                        minWidth: 58,
                        borderRadius: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "rgba(255,255,255,0.20)",
                        border: "1px solid rgba(255,255,255,0.30)",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                      }}
                    >
                      <Icon
                        sx={{
                          fontSize: 32,
                          color: "#FFFFFF",
                        }}
                      >
                        {item.icon}
                      </Icon>
                    </Box>

                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <MDTypography
                        variant="button"
                        sx={{
                          display: "block",
                          color: "#FFFFFF",
                          fontWeight: 800,
                          fontSize: "0.88rem",
                          lineHeight: 1.5,
                          letterSpacing: "0.35px",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {item.label}
                      </MDTypography>

                      <MDTypography
                        variant="caption"
                        sx={{
                          display: "block",
                          mt: 0.75,
                          color: "rgba(255,255,255,0.92)",
                          fontSize: "0.75rem",
                          lineHeight: 1.5,
                          fontWeight: 400,
                        }}
                      >
                        {item.description}
                      </MDTypography>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          mt: 1.25,
                          color: "#FFFFFF",
                          fontSize: "0.72rem",
                          fontWeight: 700,
                        }}
                      >
                        OPEN
                        <Icon sx={{ fontSize: 17 }}>arrow_forward</Icon>
                      </Box>
                    </Box>
                  </Box>
                </MDButton>
              </Grid>
            ))}
          </Grid>
        );
    }
    {
      /* <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>people_alt</Icon>}
                onClick={() => handleNavigate("servicetypes")}
              >
                SERVICE TYPES-CHARGES
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>people_alt</Icon>}
                onClick={() => handleNavigate("servicerequest")}
              >
                SERVICE REQUESTS
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>people_alt</Icon>}
                onClick={() => handleNavigate("hostelenrollement")}
              >
                HOSTEL ENROLLMENT
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>people_alt</Icon>}
                onClick={() => handleNavigate("transportenrollment")}
              >
                TRANSPORT ENROLLMENT
              </MDButton>
            </Grid>*/
    }
    {
      /*}  <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>report</Icon>}
                onClick={() => handleNavigate("backlogsreport")}
              >
                BACKLOGS REPORT
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>emoji_events</Icon>}
                onClick={() => handleNavigate("studentresulthistory")}
              >
                STUDENT RESULTS HISTORY
              </MDButton>
            </Grid>
*/
    }
    {
      /* <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>people_alt</Icon>}
                onClick={() => handleNavigate("activitycategories")}
              >
                ACTIVITY CATEGORIES
              </MDButton>
            </Grid>
            <Grid item xs={12} sm={2} mx={1} mt={2} py={1} px={2}>
              <MDButton
                fullWidth
                color="info"
                variant="gradient"
                size="large"
                sx={{ width: 200, height: "90px", fontSize: "1rem" }}
                startIcon={<Icon>people_alt</Icon>}
                onClick={() => handleNavigate("studentactivitydetailsupload")}
              >
                STUDENT ACTIVITIES
              </MDButton>
            </Grid>
            */
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                {/* HEADER - Matching Library Management System card design */}
                <MDBox
                  mx={2}
                  mt={-1}
                  py={1}
                  px={2}
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                >
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <Icon sx={{ color: "#FFFFFF" }}>school</Icon>

                    <MDTypography variant="h6" color="white">
                      STUDENT MENU
                    </MDTypography>
                  </MDBox>

                  {activeView !== "home" ? (
                    <MDButton
                      variant="contained"
                      onClick={handleBack}
                      startIcon={<Icon>arrow_back</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF",
                        backgroundColor: "rgba(255,255,255,0.18)",
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.28)",
                        },
                      }}
                    >
                      Back to Student
                    </MDButton>
                  ) : (
                    <MDButton
                      variant="contained"
                      onClick={() => navigate("/dashboard")}
                      startIcon={<Icon>dashboard</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF !important",
                        backgroundColor: "rgba(255,255,255,0.18) !important",
                        boxShadow: "none !important",
                        "& .material-icons": {
                          color: "#FFFFFF !important",
                        },
                        "&:hover": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                          boxShadow: "none !important",
                        },
                        "&:focus": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.18) !important",
                        },
                        "&:active": {
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                        },
                      }}
                    >
                      Dashboard
                    </MDButton>
                  )}
                </MDBox>

                {/* CONTENT */}
                <MDBox p={1}>{renderContent()}</MDBox>
              </Card>
            </Grid>
          </Grid>
        )}
      </MDBox>
      <MDBox display="flex" flexDirection="column" minHeight="50vh"></MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Student;
